<template>
    <div>
        <!-- Show buybutton if item is on stock and no backorder or show buybutton if item is out of stock but backorder is available. Also show if item has not been set to "may not sell"-->
        <div v-if="!$root.display.showPriceNoBuyButton || ($root.admin && $root.display.showPriceNoBuyButton)">
            <div v-if="onlyBuyWhenLoggedInCheck">
                <div v-if="((((availability != 0 && !backorder) || (availability == 0 && (backorder || preorder))) && availability != 2) || availability == 5) && loaded">
                    <transition-group :name="entry ? '' : 'bounce'" :duration="{ enter: 300, leave: 0 }">
                        <button :key="1" class="add" v-if="((showAddToBasket && (((availability != 0 || availability != 2) && (!backorder && !preorder)) || (availability == 5))))" @click="addToBasket(id)">{{this.$root.language.wsm_AddToBasket}}</button>
                        <div :key="2" v-if="(availability == 0 && (backorder || preorder)) && currentQuant == 0 && showAddToBasket">
                            <button v-if="backorder" class="add" @click="showModal = true"> backorder {{this.$root.language.wsm_AddToBasket}}</button>
                            <button v-if="!backorder && preorder" class="add notify" @click="showModal = true"><i class="fas fa-bell"></i> <span v-html="this.$root.language.wsm_Preorder"></span></button>

                        </div>
                    </transition-group>
                    <transition :name="entry ? '' : 'bounce'" :duration="{ enter: 300, leave: 0 }">
                        <div class="quantityButtons" :class="{'isSubscription' : isSubscriptionInBasket}" v-if="currentQuant != 0 && showQuant">
                            <button class="minus" @click="adjustQuantity('minus')">
                            <i class="fas fa-minus"></i>
                            </button>
                            <input disabled v-model="currentQuant" />
                            <button class="plus" @click="adjustQuantity('plus')">
                            <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </transition>
                </div>
              
            </div>
        </div>
        <!-- Out of stock, no backorder -->
        <div v-if="availability == 0 && (!backorder && !preorder)">
            <button class="add outOfStock">{{this.$root.language.wsm_OutOfStock}}</button>
        </div>
        <!-- include backorder modal -->
        <div v-if="availability == 0 && (backorder || preorder)">
            <backorderModal @addToBasket="addToBasket" v-if="showModal" @close="showModal = false" :preorder="preorder" :productid="id" :backorder="backorder" :productname="productname"></backorderModal>
        </div>
        <!-- May not be sold, no backorder -->
        <div v-if="availability == 2"> 
            <MessengerButton v-if="this.$root.messenger == true"></MessengerButton>
            <button v-if="!this.$root.messenger" class="add outOfStock">{{this.$root.language.wsm_NotForSale}}</button>
           
        </div>
        <div class="pointcardvalue" v-show="$root.pointshop && pointCardPointValue?.pointCardPointValue  > 0 && pointCardPointValue.view == 'grid'">
            <p v-html="`${$root.language.wsm_pointcard_in_box}: ${pointCardPointValue.pointCardPointValue} ${pointCardPointValue.CurrencyIso}`"></p>
        </div>
    </div>
</template>

<script>
    // CODE SPLITTING - There is linking issues when in development.
        // The chunks cannot handle our /pndk/ stuff
    //const MessengerButton = ()=>import("./messengerButton.vue");
    //const backorderModal = ()=>import("./backorder.vue");

    import MessengerButton from "./messengerButton.vue"
    import backorderModal from './backorder'
    
    export default {
        components: {
            backorderModal,            
            MessengerButton,
        },
        props: ["id", "quantity", "availability", "backorder", "preorder", "productname", "price", "isSubscriptionInBasket", "restock", "pointCardPointValue", "CurrencyIso"],
        data() {
            return {
                currentQuant: 0,
                showAddToBasket: true,
                showModal: false,
                showQuant: "",
                entry: true,
                loaded: false
            };
        },
        mounted() {
            var _that = this
            if (this.$store.state.BasketLines.length > 0) {
                this.$store.state.BasketLines.forEach((element, index) => {
                    if (element.id == this.id) {
                        this.currentQuant = element.quantity;
                    }
                })
            }
            //move this shit to 
            this.$store.subscribe((mutation, state) => {
                switch (mutation.type) {
                    case 'applyQuantityFromBasket':
                        if (state.BasketLines.length != 0) {
                            state.BasketLines.forEach(element => {
                                if (typeof state.BasketLines.find(x => x.id == _that.id) != 'undefined') {
                                    _that.currentQuant = state.BasketLines.find(x => x.id == _that.id).quantity
                                } else {
                                    _that.currentQuant = 0;
                                    this.loaded = true;
                                }
                            })
                        } else {
                            _that.currentQuant = 0;
                            this.loaded = true;
                        }
                        break;
                    case 'applyPriceList':
                        this.entry = true;
                        break;
                    case "forceLoadButtons":
                        _that.$store.dispatch('refreshBasket')
                    break;
                }
            })
        },
        watch: {
            currentQuant: {
                handler() {
                    if (this.currentQuant == 0) {
                        this.showQuant = false;
                        setTimeout(() => {
                            this.showAddToBasket = true;
                            this.loaded = true;
                        }, 100)
                    } else {
                        this.showAddToBasket = false;
                        setTimeout(() => {
                            this.showQuant = true;
                            this.loaded = true;
                        }, 100)
                    }
                }
            }
        },
        methods: {
            addToBasket: function() {
                var _that = this;
                this.entry = false;
                axios.get(window.basedir + "/ajaxRequestServlet?mode=UpdateQuantity&payload={'products':[{productID:" + this.id + ",quantity:1}], isPointShop: " + (this.$root.pointshop ? 'Y' : false) + "}", {
                    headers: {
                        'Content-type': 'application/json',
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache',
                        'Expires': '0',
                    }
                }).then((response) => {
                    if (response.data.errorMessage.length > 0) {
                        alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + response.data.errorMessage);
                    } else {
                        window.ajaxBasket.refresh();
                        this.$emit('gtag', this.id, this.productname, this.price)
                    }
                });
            },
            adjustQuantity: function(type) {
                this.entry = false;
                this.$store.dispatch('addOrRemoveQuant', {
                    id: this.id,
                    type: type,
                    currentQuant: this.currentQuant
                });
            },
        },
        computed: {
            onlyBuyWhenLoggedInCheck: function() {
                if (this.$root.display.OnlyBuyWhenLoggedIn) {
                    if (this.$root.display.loggedIn) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true
                }
            },
            restockDate: function() {
                return this.$root.language.wsm_expectedrestock.replace('$$__DATE__$$', new Date(this.restock).toLocaleDateString(window.locale.replace('_', '-'), { year: 'numeric', month: 'short', day: 'numeric' })) 
            }
        }
    };
</script>

<style lang="scss" scoped>
    #integrationTest {
        .pointcardvalue p {
            font-size: 0.8rem;
            color: #575757;
            font-weight: 600;
            margin-top: 0.4rem;
            margin-bottom: 0;
        }
        .add {
            background-position: center !important;
            transition: background 0.2s !important;
            border-radius: 3px;
            padding: 3px 8px;
            -webkit-appearance: none;
            border: 1px solid darkseagreen;
            background: #7caf63;
            color: white;
            float: right;
            cursor: pointer;
            height: 100%;
            i {
                color: white;
                font-size: 0.8em;
                vertical-align: top;
                margin-top: 2px;
            }
            &:hover{
                background: lighten(#7caf63, 5%);
            }
        }
        .notify {
            background: #004570;
            border: 1px solid #004570;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size:13px;
            span {
                color:white;
                margin-left: 0.3rem;
                line-height: normal;
                font-size: 13.3px;
            }
            &:hover {
                background: #206d9c;
                border: 1px solid #1c73a9;
            }
        }
        .nosale {
            .outOfStock {
                font-size: 0.7em;
                min-height: 22px;
            }
        }
        .outOfStock {
            background: transparent;
            color: #7caf63;
            border: 1px solid #7caf63;
            font-weight: bold;
            cursor: default;
        }
        .grid {
            .add {
                width: 100%;
                padding: 0;
                margin: 0;
                display: block;
                float: none;
                // border-radius: 0;
                padding: 6px;
            }
            .quantityButtons {
                height: 29px;
                text-align: left;
                input {
                    box-sizing: border-box;
                    width: 12%;
                    min-width: 32px;
                }
            }
        }
        .quantityButtons {
            display: flex;
            text-align: right;
            height: 23px;
            button {
                height: 100%;
                background-position: center !important;
                transition: background 0.6s !important;
                border-radius: 3px;
                border-radius: 3px;
                border-radius: 3px;
                padding: 1px 8px;
                -webkit-appearance: none;
                border: 1px solid darkseagreen;
                background: #7caf63;
                color: white;
                display: inline-block;
                margin: 0;
                cursor: pointer;
                .fas {
                    color: white;
                    font-size: 0.8em;
                }
            }
            .plus {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
            .minus {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }
        .quantityButtons.isSubscription {
            button {
                border: 1px solid #b68c3d;
	            background: #d8a64b !important;
            }
            input {
                border-top: 1px solid #b68c3d;
                border-bottom: 1px solid #b68c3d;
            }
        }
        input {
            padding: 0px;
            height: 100%;
            box-sizing: border-box;
            width: 32%;
            display: inline-block;
            text-align: center;
            color: #004570;
            background: #ffffff;
            border-top: 1px solid #7caf63;
            border-bottom: 1px solid #7caf63;
            border-right: none;
            border-left: none;
            font-size: 1.1em;
            font-weight: bold;
            vertical-align: top;
        }
        .bounce-enter-active {
            animation: bounce-in 0.5s;
        }
        .bounce-leave-active {
            animation: bounce-in 0.5s reverse;
        }
        @keyframes bounce-in {
            0% {
                transform: scale(0);
            }
            50% {
                transform: scale(1.02);
            }
            100% {
                transform: scale(1);
            }
        }
        @media screen and (max-width: 700px) {
            .grid {
                .addToBasketButton {
                    .add {
                        width: 100%;
                        min-height: 29px;
                    }
                    .quantityButtons {
                        text-align: right;
                        height: 30px;
                        margin-left: -3px;
                        input {
                            
                        }
                    }
                }
            }
            .list {
                .productActionBar {
                    .adminBtn {
                        .add {
                            width: 100%;
                            padding: 7px;
                        }
                    }
                    .addToBasketButton {
                        .add {
                            width: 100%;
                            padding: 7px;
                        }
                    }
                    .quantityButtons {
                        height: 30px;
                        margin-left: -3px;
                        input {
                            
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 440px) {
            .grid {
                .addToBasketButton {
                    .quantityButtons {
                        text-align: left;
                    }
                }
            }
        }
    }
</style>
